export const Organisation = {
	// Organisation related Api calls

	loadOrganisationReviews(params) {
		return this.service.post(
			'/api/organisation/'+params.org_main_id+'/reviews',
			params,
			response => Promise.resolve(response)
		)
	},

	loadOrganisationCompareData(params) {
		return this.service.post(
			'/api/organisation/compare',
			params,
			response => Promise.resolve(response)
		)
	}
}
